import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { selectTerm } from '@actions/creators';
import { useSlideData } from '@context/slide-data';
import { updateSelectedTerm } from '@services';
import { TermsDropdown, TermLabel } from '../styles';
import { TermsContainer } from '../styles';
import { BROWSER_STORAGE_KEYS } from '@constants';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown } from '@fortawesome/free-solid-svg-icons';
import { setBrowserStorageItem } from '@utils/browserStorage';
import { usePresentation } from '@context/presentation';
import { isAttorneyProfile } from '@utils/profileUtils';

export const SelectTerms = ({ value, options }) => {
    const { t } = useTranslation();
    const { clientViewing, client } = usePresentation();
    const { firmShortName } = client;
    const { selectedTermKey } = BROWSER_STORAGE_KEYS;
    const { data, dispatch, desktop } = useSlideData();

    const sliderOptions = [];
    // Grab only the data associated with termLength keys (filtering out currentMonthlyPayment key), and sort
    for (let key in options) {
        if (options.hasOwnProperty(key) && parseInt(key)) {
            const { termDescription } = options[key];
            sliderOptions.push({ term: key, termDescription });
        }
    }

    const logMessage = () => {
        console.log('Dropdown cannot be adjusted');
    };

    const handleChange = (evt) => {
        const { value } = evt.target;
        const valueAsNumber = parseInt(value);

        const terms = sliderOptions.map(option => parseInt(option.term));

        if (terms.includes(valueAsNumber)) {
            const { id } = data;

            dispatch(selectTerm(valueAsNumber, id));
            updateSelectedTerm({ slideId: id, term: valueAsNumber });

            setBrowserStorageItem(`${selectedTermKey}_${id}`, valueAsNumber);
        }
    };

    // If the rep is using the dropdown, dropdown can be adjusted
    // Otherwise, the dropdown select is read-only
    return (
        <TermsContainer desktop={desktop}>
            <TermLabel htmlFor='terms'>{t('term_options.select_new')}</TermLabel>
            <TermsDropdown
                clientViewing={clientViewing}
                id='terms'
                name='terms'
                onChange={clientViewing ? logMessage : handleChange}
                value={value}>
                    {
                        sliderOptions.map(option => (
                            <option key={option.term} value={option.term}>
                                {isAttorneyProfile(firmShortName) ? option.termDescription : option.term} {t('global.months')}
                            </option>
                        )) 
                    }
            </TermsDropdown>
        </TermsContainer>
    );
};

export default SelectTerms;
